module.exports = __webpack_public_path__ + "static/Construction-hero-c3b571343bae5a1e6eae15314d7b5ff9.png";